import React, { useEffect } from "react";
import * as binderIds from "../enums/binderIds";
import * as docketPropTypes from "../docketPropTypes";
import * as pageActions from "../actions/pageActions";
import * as pageReducer from "../reducers/pageReducer";
import * as users from "../lib/api/users";
import { bool, node, func, string } from "prop-types";
import { connect } from "react-redux";

export const navigatorProps = {
	binderDirty: bool,
	children: node,
	clientOutdated: bool,
	clientUnauthorized: bool,
	initialRender: bool,
	isAuthenticated: bool,
	isBinderPage: bool,
	location: docketPropTypes.routerLocation,
	pageSetInitialRender: func,
	params: docketPropTypes.routerParams,
	sectionName: string,
	targetName: string,
	title: string,
};

const Navigator = ({
	binderDirty,
	children,
	clientOutdated = pageReducer.defaultState.clientOutdated,
	clientUnauthorized = pageReducer.defaultState.clientUnauthorized,
	initialRender = pageReducer.defaultState.initialRender,
	isAuthenticated = false,
	isBinderPage = false,
	location,
	pageSetInitialRender,
	params = {},
	sectionName,
	targetName,
	title,
}) => {
	const refresh = () => {
		if (initialRender || !clientOutdated) {
			return false;
		}

		const binderId = params.binderId ? parseInt(params.binderId, 10) : null;
		const isBinderUnsaved = binderId === binderIds.UNASSIGNED || binderDirty;
		if (isBinderPage && isBinderUnsaved) {
			return false;
		}

		window.location.href = location.pathname + window.location.search;
		return true;
	};

	const trackUsage = () => {
		if (!isAuthenticated || clientUnauthorized) {
			return Promise.resolve();
		}

		if (params.binderId === null || params.binderId === undefined) {
			return users.navigation();
		}

		if (
			params.binderId !== null &&
			params.binderId !== undefined &&
			params.tabIndex !== null &&
			params.tabIndex !== undefined &&
			targetName !== undefined
		) {
			return users.navigation(targetName, sectionName);
		}

		return Promise.resolve();
	};

	useEffect(() => {
		let mounted = true;

		if (title && document.title !== title) {
			document.title = title;
		}

		const refreshed = refresh();
		if (refreshed) {
			return;
		}

		const usageRequest = trackUsage().catch(err => console.log(err));

		if (initialRender) {
			pageSetInitialRender(false);
		}

		return () => {
			mounted = false;
			if (usageRequest?.cancel instanceof Function) {
				usageRequest.cancel();
			}
		};
	}, [location.pathname, isAuthenticated, clientUnauthorized, targetName, sectionName]);

	useEffect(() => {
		const pathChanged = location.pathname !== location.pathname;

		if (pathChanged || targetName !== targetName || sectionName !== sectionName) {
			const usageRequest = trackUsage().catch(err => console.log(err));
			return () => {
				if (usageRequest?.cancel instanceof Function) {
					usageRequest.cancel();
				}
			};
		}
	}, [location.pathname, isAuthenticated, clientUnauthorized, targetName, sectionName]);

	return children || null;
};

Navigator.propTypes = navigatorProps;

const mapStateToProps = state => ({
	clientOutdated: state.page.clientOutdated,
	clientUnauthorized: state.page.clientUnauthorized,
	initialRender: state.page.initialRender,
	isAuthenticated: state.session.isAuthenticated,
});

export default connect(
	mapStateToProps,
	{
		pageSetInitialRender: pageActions.pageSetInitialRender,
	},
)(Navigator);
